/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-20T20:38:25.853
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getDroomConEstateInfoEditInit,
	getDroomConEstateInfoView
} from '@api/storagemanage/DroomConEstateInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getDroomConEstateInfoEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getDroomConEstateInfoEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getDroomConEstateInfoView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getDroomConEstateInfoView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
